export { AuthingGuard as default } from '@authing/react-ui-components';
